import React from 'react';
import { Tag } from 'antd';

interface LiveTagProps {
  badgeValue?: number;
}

/**
 * Display component showing live shipment count with a badge indicator.
 *
 * @param badgeValue - Number of active shipments (defaults to 0 if not provided)
 */
const LiveTag: React.FC<LiveTagProps> = ({ badgeValue }) => {
  return (
    <Tag
      className='live-tag-wrapper'
      style={{
        backgroundColor: 'var(--thin-green)',
        borderColor: 'var(--thin-green)',
        color: 'var(--green-900)',
      }}
    >
      <Tag
        className='inner-tag'
        style={{
          backgroundColor: 'var(--green-900)',
          borderColor: 'var(--green-900)',
          color: '#fff',
        }}
      >
        ⚪ LIVE
      </Tag>
      {badgeValue ?? 0} active shipments
    </Tag>
  );
};

export default LiveTag;
